import axios from 'axios';
import { API_URL } from './api';

const VAPID_PUBLIC_KEY = "BMhsNUhPlF303kRTV5ohKh8Iwx72SfJHQI4F4rF2SN2Ds0ZcbiJj2DCPqc1ph8xJ0lrrL9mPR2IHZWi7VdiF3Lo";

function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - base64String.length % 4) % 4);
  const base64 = (base64String + padding)
    .replace(/\-/g, '+')
    .replace(/_/g, '/');

  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);

  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}

export const subscribeUserToPush = async () => {
  try {
    if (!('serviceWorker' in navigator)) {
      console.warn('Service Worker not supported');
      return;
    }

    const registration = await navigator.serviceWorker.ready;
    
    // Subscribe
    const subscription = await registration.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(VAPID_PUBLIC_KEY)
    });

    // Send to backend
    const token = localStorage.getItem('token');
    await axios.post(`${API_URL}/notifications/subscribe`, subscription, {
      headers: { Authorization: `Bearer ${token}` }
    });

    console.log('User is subscribed.');
    return true;
  } catch (err) {
    console.error('Failed to subscribe user:', err);
    return false;
  }
};
